export default "<div class=\"widgets-table-wrapper\">\n  <widgets></widgets>\n</div>\n"